













































import {Component, Mixins} from 'vue-mixin-decorator';
import {getModule} from 'vuex-module-decorators';
import {Inject} from 'inversify-props';

import {AntennaType} from '@/model/lora/AntennaType';

import {ILoraHardwareService} from '@/services/lora/ILoraHardware.service';

import LoraHardwareStore from '@/store/lora/LoraHardware.store';
import LoraRegionEditor from '@/components/Lora/LoraRegionEditor.vue';
import LoraAntennaEditor from '@/components/Lora/LoraAntennaEditor.vue';
import {Notify} from '@/utils/Notify';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {LoraAntennaEditor, LoraRegionEditor},
})
export default class LoraHardware extends Mixins<BaseComponent>(BaseComponent) {
  @Inject(Symbol.for('ILoraHardwareService'))
  private loraHardwareService!: ILoraHardwareService;

  private loraHardwareStore: LoraHardwareStore = getModule(LoraHardwareStore, this.$store);

  private saving = false;

  private antennaType: AntennaType | null = null;

  private region: string | null = null;

  private async mounted() {
    await this.loraHardwareStore.fetchAntenna();
    this.antennaType = this.loraHardwareStore.Antenna;

    await this.loraHardwareStore.fetchRegion();
    this.region = this.loraHardwareStore.Region;
  }

  private async save() {
    this.saving = true;

    if (this.antennaType && this.antennaType !== this.loraHardwareStore.Antenna) {
      try {
        this.logger.info(`Settings LoRa antenna type to '${this.antennaType}'`);
        await this.loraHardwareService.setAntennaType(this.antennaType.Id);
        this.loraHardwareStore.setAntenna(this.antennaType);
        Notify.Info(this.logger, `Antenna type updated. Please restart the forwarder to apply changes.`);
      } catch (error) {
        Notify.Error(this.logger, `Could not set LoRa antenna type`, error);
      }
    }

    if (this.region && this.region !== this.loraHardwareStore.Region) {
      try {
        this.logger.info(`Settings LoRa region to '${this.region}'`);
        await this.loraHardwareService.setRegion(this.region);
        this.loraHardwareStore.setRegion(this.region);
        Notify.Info(this.logger, `Region updated. Please restart the forwarder to apply changes.`);
      } catch (error) {
        Notify.Error(this.logger, `Could not set LoRa region`, error);
      }
    }

    this.saving = false;
  }
}
